<template>
  <div class="login-page-main">
    <div class="row">
      <div class="col-12 mt-2 text-center">
        <span class="text-header">Core Auth</span>
      </div>
      <div class="col-12 text-center mb-2" style="margin-top: -15px;">
        <span style="font-size: 20px!important;" class="text-header">Single Sign On</span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5 col-2 col-md-3">
      </div>
      <div class="col-lg-2 col-8 col-md-6 shadow p-3 bg-body rounded form-background">
        <form @submit.prevent="controlRecaptcha" :class="[usernameValidFunction && passwordValidFunction  ? '' : 'was-validated']" novalidate>
          <!-- <label class="text-style">Email</label>-->
          <div class="input-group mb-3 mt-3" >
            <span class="input-group-text"><font-awesome-icon icon="envelope"/></span>
            <input id="email" type="text" class="form-control" name="email" placeholder="Email" v-model="username" required autocomplete="off">
            <div class = "invalid-feedback" v-if="!usernameValid"> Please fill the email. </div>
            <!--<div class = "invalid-feedback" v-if="!validateEmail"> Please fill the email. </div>-->

          </div>
          <!--<label class="text-style">Password</label>-->
          <div class="input-group mt-2 mb-3">
            <span class="input-group-text"><font-awesome-icon icon="lock"/></span>
            <input id="password" type="password" class="form-control" name="password" placeholder="Password" v-model="password" required autocomplete="off"
                   oninvalid="this.setCustomValidity('Password cannot be blank')"
                   oninput="setCustomValidity('')">
            <div class = "invalid-feedback" v-if="!passwordValid"> Please fill the password. </div>
          </div>
          <div class="mb-1 mt-2 p-2 text-center">
            <button class="btn btn-primary btn-block login-btn">
              <font-awesome-icon :icon="isLoading ? 'spinner' : 'sign-in-alt'" :spin="isLoading"/>
              <span class="p-2" style="font-size: 20px;font-family: Helvetica, Arial, sans-serif;">Login</span>
            </button>
          </div>
          <div style="text-align:-webkit-center" v-if="showRecaptcha">
            <vue-recaptcha sitekey="6Le_ZfcfAAAAAJPwbxhS7gUo4TAS_PTqtDl5oaqo" @verify="myveri" ></vue-recaptcha>
            <small style="color: #dc3545">{{pleaseTickRecaptchaMessage}}</small>
          </div>
        </form>

      </div>
      <div class="col-lg-5 col-2 col-md-3">
      </div>
    </div>
  </div>

</template>


<script>
    import {createNamespacedHelpers} from 'vuex';
    import {loadingMixin} from "../../utils/mixins";
    import { VueRecaptcha } from 'vue-recaptcha';
    const {mapActions} = createNamespacedHelpers('auth');

    export default {
        name: "Login",
        mixins: [loadingMixin],
        components: {
          VueRecaptcha
        },
        data() {
          return {
            username: '@corendon-airlines.com',
            usernameValid:true,
            password: '',
            passwordValid:true,
            recaptcha:null,
            pleaseTickRecaptchaMessage :'',
            recaptchaVerified: false,
            showRecaptcha: false,

          }
        },
        async created() {

        },
        methods: {
            ...mapActions(["login"]),
            myveri(response){
              this.recaptcha = response;
              this.recaptchaVerified = true;
              this.pleaseTickRecaptchaMessage = '';
            },
            controlRecaptcha(){
              if (this.username === '') {
                this.username = '';
                this.password = '';
                this.usernameValid = false;
                this.passwordValid = false;
                return;
              }
              if(this.password === '' ){
                this.password = '';
                this.usernameValid = false;
                this.passwordValid = false;
                return;
              }
              if (!this.recaptchaVerified && this.showRecaptcha){
                this.pleaseTickRecaptchaMessage = 'Please solve captcha!';
                return true;
              }else{
                this.tryLogin();
              }
            },
            async tryLogin() {
                this.showLoading();
                try {
                  await this.login({email: this.email, password: this.password});
                  this.$notify({title: "Success", text: "You have just logged in successfully.", type: "success",});

                } catch (e) {
                  this.showRecaptcha = true;
                  this.$notify({title: "Error", text: e.message, type: "error"});
                } finally {
                  this.hideLoading();
                }
            },
        },
        computed: {
            email() {
                return `${this.username}`;
            },
          usernameValidFunction() {
            if(this.username == '' && this.usernameValid == true) {
             return true;
            }else{
              return false;
            }
          },
          passwordValidFunction(){
            if(this.password == '' && this.passwordValid == true) {
              return true;
            }else{
              return false;
            }
          },
          recaptchaFunction(){
              if(this.recaptcha != null){
                return true
              }else{
                return false;
              }
          }
        }

    }
</script>

<style scoped>
    .login-page-main{
        background-image: url("../../assets/images/CAI.jpg");
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: 50% 50% !important;
    }
    .form-background{
      background-color: #f0f8ff99 !important;
      margin-left: 10px;
      margin-top: 135px;
    }
    .form-control{
      border: 1px solid #9bbbe8;
      height: 50px;
      font-family: Helvetica, sans-serif;
      font-size: 14px;
    }
    .g-recaptcha {
      position: relative;
      width: 100%;
      background: #f9f9f9;
      overflow: hidden;
    }
    .text-header{
      font-size: 50px;
      font-family: Helvetica, Arial, sans-serif;
      color: #fff;
     /*text-shadow: 1px 1px 1px #d51317;*/
      text-shadow: 1px 2px 2px #383838;
    }
    .login-btn{
      width:100%;
      background-color:#56759c
    }
    @media ( max-width : 768px) {
      .form-background{
        margin-top: 10px;
        margin-left: unset;
      }
      .login-page-main{
        background-position:10%50% !important;
      }
      .login-btn{
        width:unset;
      }
    }
    .login-btn:hover{
      background-color: #1c35768a;
    }
    .login-btn:first-child:active{
      background-color: #1c35768a;
    }

</style>
